export default __webpack_public_path__ + "static/media/gray-baggage.07db3b8e.svg";